import DemoVideoEdit from "./DemoVideoEdit";
import DemoVideoCreate from "./DemoVideoCreate";
import DemoVideoShow from "./DemoVideoShow";
import DemoVideosList from "./DemoVideosList";

export default {
    list: DemoVideosList,
    edit: DemoVideoEdit,
    create: DemoVideoCreate,
    show: DemoVideoShow,
};
